import React from 'react'
import '../BestuurPage/Style.css'
import useTitle from '../../useTitle'

const BestuurPage = () => {
  useTitle("Our Team");
  return (
    <>
        <div className='bestuurPageContainer'>
          <div className='bestuurItem'>
            <img src='/images/patrick1.png' className='photoOfPresident' alt='pic of president' />
            <div className='descriptionOfBestuurItem'>
              <h1 className='nameOfBestuur'>Patrick Vranckx</h1>
              <h3 className='titleOfBestuur'>Head Coach</h3>
              <h3 className='gradeOfBestuur'>President CJJ Belgian Federation</h3>
              <p className='gradeOfBestuur'>5th dan Combat Ju-Jutsu</p>
              <p className='styleOfBestuur'>Style: Combat Ju-Jutsu</p>
            </div>
          </div>
        </div>

        <div className="dividerTwoBestuur"></div>
        {/* Coaches */}
        <div className='coachesSection'>
          <div className='BestuursItemTwo'>
            <div className='bestuurItem'>
            <img src='/images/joeri.jpeg' className='photoOfPresident' alt='pic of coach' />
              <div className='descriptionOfBestuurItem'>
                <h1 className='nameOfBestuurTwo'>Joeri Winckelmans</h1>
                <h3 className='titleOfBestuurTwo'>Coach / Athlete</h3>
                <p className='styleOfBestuurTwo'>Style: Combat Ju-Jutsu</p>
              </div>
            </div>
          </div>

          <div className='BestuursItemTwo'>
            <div className='bestuurItem'>
            <img src='/images/celeste.jpeg' className='photoOfPresident' alt='pic of coach, athlete' />
              <div className='descriptionOfBestuurItem'>
                <h1 className='nameOfBestuurTwo'>Celeste Vranckx</h1>
                <h3 className='titleOfBestuurTwo'>Coach / Athlete</h3>
                <h3 className='gradeOfBestuurTwo'>1st dan Combat Ju-Jutsu</h3>
                <p className='styleOfBestuurTwo'>Style: Combat Ju-Jutsu</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="dividerThreeBestuur"></div>
        
           <div className='coachesSectionTwo'>

          <div className='BestuursItemTwo'>
            <div className='bestuurItem'>
            <img src='/images/mats.jpeg' className='photoOfPresident' alt='pic of athlete' />
              <div className='descriptionOfBestuurItem'>
                <h1 className='nameOfBestuurThree'>Mats Van Bokhoven</h1>
                <h3 className='titleOfBestuurThree'>Athlete</h3>
                <p className='styleOfBestuurThree'>Style: Combat Ju-Jutsu</p>
              </div>
            </div>
          </div>

           <div className='BestuursItemTwo'>
            <div className='bestuurItem'>
            <img src='/images/yonus.jpeg' className='photoOfPresident' alt='pic of athlete' />
              <div className='descriptionOfBestuurItem'>
                <h1 className='nameOfBestuurThree'>Yonus Niang</h1>
                <h3 className='titleOfBestuurThree'>Athlete</h3>
                <p className='styleOfBestuurThree'>Style: Combat Ju-Jutsu</p>
              </div>
            </div>
          </div>
        </div>
        
        

        <div className="dividerTwoBestuur"></div>

        {/* Athletes */}
        <div className='coachesSection'>
          <div className='BestuursItemTwo'>
            <div className='bestuurItem'>
            <img src='/images/sven.jpeg' className='photoOfPresident' alt='pic of athlete' />
              <div className='descriptionOfBestuurItem'>
                <h1 className='nameOfBestuurTwo'>Sven De Vos</h1>
                <h3 className='titleOfBestuurTwo'>Athlete</h3>
                <p className='styleOfBestuurTwo'>Style: Combat Ju-Jutsu</p>
              </div>
            </div>
          </div>

          <div className='BestuursItemTwo'>
            <div className='bestuurItem'>
            <img src='/images/cjjbf-placeholder.png' className='photoOfPresident' alt='pic of athlete' />
              <div className='descriptionOfBestuurItem'>
                <h1 className='nameOfBestuurTwo'>Olivier Tomaszewski</h1>
                <h3 className='titleOfBestuurTwo'>Athlete</h3>
                <p className='styleOfBestuurTwo'>Style: Combat Ju-Jutsu</p>
              </div>
            </div>
          </div>

        </div>

        <div className="dividerThreeBestuur"></div>

        {/* Athletes */}
        <div className='coachesSectionTwo'>

          <div className='BestuursItemTwo'>
            <div className='bestuurItem'>
            <img src='/images/gabriella.jpeg' className='photoOfPresident' alt='pic of athlete' />
              <div className='descriptionOfBestuurItem'>
                <h1 className='nameOfBestuurThree'>Gabriella Gorlewska</h1>
                <h3 className='titleOfBestuurThree'>Athlete</h3>
                <p className='styleOfBestuurThree'>Style: Combat Ju-Jutsu</p>
              </div>
            </div>
          </div>

           <div className='BestuursItemTwo'>
            <div className='bestuurItem'>
            <img src='/images/marcell.jpeg' className='photoOfPresident' alt='pic of athlete' />
              <div className='descriptionOfBestuurItem'>
                <h1 className='nameOfBestuurThree'>Marcell Gorlewski</h1>
                <h3 className='titleOfBestuurThree'>Athlete</h3>
                <p className='styleOfBestuurThree'>Style: Combat Ju-Jutsu</p>
              </div>
            </div>
          </div>
        </div>

        <div className="dividerTwoBestuur"></div>

        {/* Athletes */}
        <div className='coachesSection'>
          <div className='BestuursItemTwo'>
            <div className='bestuurItem'>
            <img src='/images/alan.jpg' className='photoOfPresident' alt='pic of athlete' />
              <div className='descriptionOfBestuurItem'>
                <h1 className='nameOfBestuurTwo'>Alan Rogala</h1>
                <h3 className='titleOfBestuurTwo'>Athlete</h3>
                <p className='styleOfBestuurTwo'>Style: Combat Ju-Jutsu</p>
              </div>
            </div>
          </div>

          <div className='BestuursItemTwo'>
            <div className='bestuurItem'>
            <img src='/images/cjjbf-placeholder.png' className='photoOfPresident' alt='pic of athlete' />
              <div className='descriptionOfBestuurItem'>
                <h1 className='nameOfBestuurTwo'>Lenn Breuur</h1>
                <h3 className='titleOfBestuurTwo'>Athlete</h3>
                <p className='styleOfBestuurTwo'>Style: Combat Ju-Jutsu</p>
              </div>
            </div>
          </div>

        </div>

        <div className="dividerThreeBestuur"></div>
        {/* Athletes */}
        <div className='coachesSectionTwo'>
          <div className='BestuursItemTwo'>
            <div className='bestuurItem'>
            <img src='/images/cjjbf-placeholder.png' className='photoOfPresident' alt='pic of athlete' />
              <div className='descriptionOfBestuurItem'>
                <h1 className='nameOfBestuurThree'>Azra Özkan</h1>
                <h3 className='titleOfBestuurThree'>Athlete</h3>
                <p className='styleOfBestuurThree'>Style: Combat Ju-Jutsu</p>
              </div>
            </div>
          </div>
         
        </div>
    </>
  )
}

export default BestuurPage;